import React from 'react';
import TopicsPageLayout from '../components/TopicsPageLayout.jsx';
import TopicsRouter from '../components/TopicsRouter.jsx';
import topicData from './caffeine.json';

const Caffeine = () => {
  return (
    <div className="topic-page-container">
        <TopicsPageLayout
            
            description="Coffee culture, caffeine effects, and beverage vocabulary. B2 level grammar, reading, and discussion exercises."
            level="B2"
            title="Caffeine"
            image="/Images/caffeine1.webp"
            seoTitle="Free English Lesson Plans: Caffeine"
            seoDescription="Coffee culture, caffeine effects, and beverage vocabulary. B2 level grammar, reading, and discussion exercises."
        >
            {topicData.map((section, index) => (
                <div key={index} className="lesson-section-wrapper">
                    <TopicsRouter sectionData={section} />
                </div>
            ))}
        </TopicsPageLayout>
    </div>
  );
};

export default Caffeine;


